import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { NgbDate, NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { saveAs } from 'file-saver'; 'file-saver';

import { PedidoIntervencaoDataService } from 'src/app/core/services/pedidoIntervencao-crud.service';
import { ContratoDataService } from 'src/app/core/services/contrato-crud.service';
import { EntidadeDataService } from 'src/app/core/services/entidade-crud.service';
import { ReferenceDataService } from 'src/app/core/services/reference-data.service';
import { PedidoIntervencao } from 'src/app/model/pedidoIntervencao/pedidoIntervencao';
import { ContratoSearchFilter } from 'src/app/model/contrato/contratoSearchFilter';
import { FileInfo } from 'src/app/shared/model/generic/fileInfo';
import { Contrato } from 'src/app/model/contrato/contrato';

@Component({
    selector: 'app-pedidointervencao-edit',
    templateUrl: './pedidoIntervencao-edit.component.html',
    styleUrls: ['./pedidoIntervencao-edit.component.css'],
    standalone: false
})
export class PedidoIntervercaoEditComponent implements OnInit, OnDestroy {
  @ViewChild('modalHistoricoEstados') modalHistoricoEstados: any;
  @ViewChild('modalCancelarPedido') modalCancelarPedido: any;
  @ViewChild('modalFecharPedido') modalFecharPedido: any;

  public pedidoIntervencaoId: number;
  public pedidoIntervencao?: PedidoIntervencao;
  public contrato?: Contrato;
  public priting: boolean;
  public canceling: boolean;
  public closing: boolean;
  public saving: boolean;
  public autorizacaoEstado: any;
  public fornecedores: any;
  public fornecedoresCC: any;
  public oficinas: any;
  public oficinasCC: any;
  public tipoIntervencao: any;
  public artigoFamilia: any;
  public popupListData: any;

  public ngbMinDataEntrega: NgbDate;
  public ngbDataEntradaOficina: NgbDate;
  public ngbDataEntrada: NgbDate;
  public dataEntrada: Date;
  public ngbDataEntrega: NgbDate;
  public dataEntrega: Date;
  public observacoes: string;

  public pedidoForm: UntypedFormGroup = this.formBuilder.group({
    estado: new UntypedFormControl(null),
    data: new UntypedFormControl(null),
    dataEntradaOficina: new UntypedFormControl(null),
    numContrato: new UntypedFormControl(null),
    matricula: new UntypedFormControl(null),
    produto: new UntypedFormControl(null, [Validators.required]),
    fornecedorId: new UntypedFormControl(null, [Validators.required]),
    oficinaId: new UntypedFormControl(null),
    numKms: new UntypedFormControl(null, [Validators.required]),
    descritivo: new UntypedFormControl(null, [Validators.required, Validators.maxLength(512)]),
    tipoIntervencao: new UntypedFormControl(null, [Validators.required]),
    tipoOperacao: new UntypedFormControl(null, [Validators.required])
  });

  private sub: any;

  constructor(
    private formBuilder: UntypedFormBuilder, private route: ActivatedRoute, private router: Router, protected modalService: NgbModal,
    private dataService: PedidoIntervencaoDataService, private entidadeDataService: EntidadeDataService,
    private contratoDataService: ContratoDataService, private referenceDataService: ReferenceDataService) {

    this.pedidoIntervencao = new PedidoIntervencao('pedidoIntervencaoId');
    this.referenceData();
  }

  ngOnInit(): void {
    this.sub = this.route.params.subscribe((params: { [x: string]: string | number; }) => {
      const newLocal = 'pedidoIntervencaoId';
      this.pedidoIntervencaoId = +params[newLocal];

      if (isNaN(this.pedidoIntervencaoId)) { this.pedidoIntervencaoId = -1; }

      this.getPedidoIntervencao();
    });
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  public setPedidoForm = (): void => {
    this.pedidoForm.patchValue({ estado: this.pedidoIntervencao.estado });
    this.pedidoForm.patchValue({ data: this.pedidoIntervencao.data });
    this.pedidoForm.patchValue({ numContrato: this.pedidoIntervencao?.numContrato });
    this.pedidoForm.patchValue({ matricula: this.pedidoIntervencao?.matricula });
    this.pedidoForm.patchValue({ produto: this.pedidoIntervencao?.produto });
    this.pedidoForm.patchValue({ fornecedorId: this.pedidoIntervencao?.fornecedorId });
    this.pedidoForm.patchValue({ oficinaId: this.pedidoIntervencao?.oficinaId });
    this.pedidoForm.patchValue({ numKms: this.pedidoIntervencao?.numKms });
    this.pedidoForm.patchValue({ descritivo: this.pedidoIntervencao?.descritivo });
    this.pedidoForm.patchValue({ tipoIntervencao: this.pedidoIntervencao?.tipoIntervencao });
    this.pedidoForm.patchValue({ tipoOperacao: this.pedidoIntervencao?.artigoFamilia });

    if (this.pedidoIntervencao?.dataEntradaOficina) {
      if (this.pedidoIntervencao?.dataEntradaOficina) {
        var dataEntrada = new Date(this.pedidoIntervencao?.dataEntradaOficina);
        this.pedidoForm.patchValue({ dataEntradaOficina: dataEntrada });
        this.ngbDataEntradaOficina = 
          new NgbDate(dataEntrada.getFullYear(), dataEntrada.getMonth()+1, dataEntrada.getDate());
      }
    }

    if (this.pedidoIntervencao.update) {
      this.pedidoForm.controls['numContrato'].disable();
      this.pedidoForm.controls['matricula'].disable();
      this.pedidoForm.controls['fornecedorId'].disable();
      this.pedidoForm.controls['oficinaId'].disable();
    }
  }

  public getPedidoIntervencao = () => {
    this.dataService
      .get(this.pedidoIntervencaoId)
      .subscribe((data: PedidoIntervencao) => {
        if (data) {
          this.getFornecedores();
          this.pedidoIntervencao = data;
          this.setPedidoForm();
          this.getOficinas();
          this.getTipoOperacao();

          if (this.isReadOnly()) {
            this.pedidoForm.disable();
          }
        }
      });
  }

  public isUpdate = () => {
    return this.pedidoIntervencao && this.pedidoIntervencao?.update;
  }

  public isReadOnly = () => {
    return this.pedidoIntervencao && this.pedidoIntervencao?.readOnly;
  }

  public permiteCancelarPedido = () => {
    return this.pedidoIntervencao && !this.pedidoIntervencao?.readOnly &&
      (this.pedidoIntervencao.autorizacaoEstadoId == 10 || this.pedidoIntervencao.autorizacaoEstadoId == 11);
  }

  public permiteFecharPedido = () => {
    return this.pedidoIntervencao &&
      (this.pedidoIntervencao.autorizacaoEstadoId == 3 || this.pedidoIntervencao.autorizacaoEstadoId == 11);
  }

  public imprimirPedido = () => {
    this.priting = true;
    this.dataService
      .imprimir(this.pedidoIntervencaoId)
      .subscribe((response: FileInfo) => {
        console.log('Download de file(s).');
        this.priting = false;
        saveAs(response.content, response.filename);
      },
        (error: any) => {
          console.log(error);
        });
  }

  public showHistoricoEstado = () => {
    this.dataService
      .getHistoricoEstados(this.pedidoIntervencaoId)
      .subscribe((response: any) => {
        this.popupListData = response;
        const modalOptions: NgbModalOptions = {
          size: 'lg',
          centered: true,
          backdrop: true,
          backdropClass: 'modal-backdrop'
        }
        this.modalService
          .open(this.modalHistoricoEstados, modalOptions).result
          .then((result) => {

          }).catch((error) => {

          });
      });
  }

  public cancelarPedido = () => {
    const modalOptions: NgbModalOptions = {
      backdrop: true,
      backdropClass: 'modal-backdrop'
    };
    this.modalService
      .open(this.modalCancelarPedido, modalOptions).result
      .then((resul) => {
        if (resul === 'Confirm') {
          this.canceling = true;
          this.dataService
            .cancelarPedido(this.pedidoIntervencaoId, this.observacoes)
            .subscribe((response) => {
              if (response) {
                this.canceling = false;
                this.getPedidoIntervencao();
              }
            },
              (error) => {
              });
        }
      }).catch((error) => {
        // this.message = error;
      })
      .finally(() => {
        // if (callBack) {
        //   callBack(buttonClicked, row);
        // }
      });
  }

  public fecharPedido = () => {
    // data de entrega nunca pode ser inferior à data de registo do registo de intervenção
    const dataRegisto = new Date(this.pedidoIntervencao.data);
    this.ngbMinDataEntrega = new NgbDate(dataRegisto.getFullYear(), dataRegisto.getMonth() + 1, dataRegisto.getDate());

    if (this.pedidoIntervencao?.dataEntradaOficina) {
      this.dataEntrada = new Date(this.pedidoIntervencao.dataEntradaOficina);
      this.ngbDataEntrada = new NgbDate(this.dataEntrada.getFullYear(), this.dataEntrada.getMonth()+1, this.dataEntrada.getDate());
    }

    const modalOptions: NgbModalOptions = {
      backdrop: true,
      backdropClass: 'modal-backdrop'
    };

    this.modalService
      .open(this.modalFecharPedido, modalOptions).result
      .then((resul) => {
        if (resul === 'Confirm') {
          this.closing = true;
          this.dataService
            .fecharPedido(this.pedidoIntervencaoId, this.dataEntrada, this.dataEntrega, this.observacoes)
            .subscribe((response) => {
              if (response) {
                this.closing = false;
                this.getPedidoIntervencao();
              }
            },
              (error) => {
              });
        }
      }).catch((error) => {
        // this.message = error;
      })
      .finally(() => {
        // if (callBack) {
        //   callBack(buttonClicked, row);
        // }
      });
  }

  public getFornecedores = (): any => {
    if (this.contrato && this.contrato.fornecedores && this.contrato.fornecedores.length > 0) {
      this.fornecedoresCC = this.fornecedores
        .filter((item: any) => this.contrato.fornecedores.includes(item.entidadeId));
    } else {
      this.fornecedoresCC = this.fornecedores;
    }
  }

  public getOficinas = (): any => {
    const fornecedorId = this.pedidoForm?.get('fornecedorId').value;
    if (fornecedorId) {
      if (this.contrato && this.contrato.oficinas && this.contrato.oficinas.length > 0) {
        this.oficinasCC = this.oficinas
          .filter((item: any) => item.entidadeId == fornecedorId && this.contrato.oficinas.includes(item.oficinaId));
      } else {
        this.oficinasCC = this.oficinas
          .filter((item: any) => item.entidadeId == fornecedorId);
      }
    }
  }

  public getTipoOperacao = (): any => {
    const tipoIntervencaoId = this.pedidoForm?.get('tipoIntervencao').value;
    if (tipoIntervencaoId) {
      this.referenceDataService
        .getArtigoFamilia()
        .subscribe((data: any) => {
          this.artigoFamilia = data.filter(
            (element: any) => tipoIntervencaoId.includes(element.tipoIntervencaoId)
          );
        });
    }
  }

  public searchContrato = (text: string, matricula: boolean): void => {
    this.pedidoIntervencao.contratoId = undefined;
    this.pedidoForm.patchValue({ numContrato: null });
    this.pedidoForm.patchValue({ matricula: null });
    this.pedidoForm.patchValue({ produto: null });

    if (text === '') {
      return;
    }

    const filter = new ContratoSearchFilter();
    filter.returnTotalCount = true;
    if (matricula) {
      filter.numContrato = '';
      filter.matricula = text;
    } else {
      filter.numContrato = text;
      filter.matricula = '';
    }

    this.contratoDataService
      .search(filter)
      .subscribe((response: any) => {
        if ((response as any).dataList) {
          this.contrato = (response as any).dataList[0];

          this.pedidoIntervencao.contratoId = this.contrato.id;
          this.pedidoForm.patchValue({ numContrato: this.contrato.numContrato });
          this.pedidoForm.patchValue({ matricula: this.contrato.matricula });
          this.pedidoForm.patchValue({ produto: this.contrato.produto });

          this.getFornecedores();
        }
      }, (error: any) => {
        console.log(error);
      });
  }

  public back = (): void => {
    this.router.navigate(['/pedidoIntervencao'], { queryParamsHandling: 'preserve' });
  }

  public save = (): void => {
    if (this.pedidoForm.valid) {
      this.pedidoIntervencao.data = new Date();
      this.pedidoIntervencao.dataEntradaOficina = this.pedidoForm.get('dataEntradaOficina').value;
      this.pedidoIntervencao.fornecedorId = this.pedidoForm.get('fornecedorId').value;
      this.pedidoIntervencao.oficinaId = this.pedidoForm.get('oficinaId').value;
      this.pedidoIntervencao.numKms = this.pedidoForm.get('numKms').value;
      this.pedidoIntervencao.descritivo = this.pedidoForm.get('descritivo').value;
      this.pedidoIntervencao.tipoIntervencao = this.pedidoForm.get('tipoIntervencao').value;
      this.pedidoIntervencao.artigoFamilia = this.pedidoForm.get('tipoOperacao').value;
    }

    this.saving = true;
    this.dataService
      .save(this.pedidoIntervencao)
      .subscribe((response) => {
        this.saving = false;
        this.router.navigate(['/pedidoIntervencao/' + response.pedidoIntervencaoId.toString()], { queryParamsHandling: 'preserve' });
      },
        (error) => {
        });
  }

  private referenceData = (): void => {
    this.entidadeDataService
      .getFornecedores()
      .subscribe((data: any) => {
        this.fornecedores = data;
      });

    this.referenceDataService
      .getOficina()
      .subscribe((data: any) => {
        this.oficinas = data;
      })

    this.referenceDataService
      .getTipoIntervencao()
      .subscribe((data: any) => {
        this.tipoIntervencao = data;
      });
  }

  selectDataEntrada(value: NgbDate) {
    this.dataEntrada = new Date(Date.UTC(value.year, value.month - 1, value.day, 0, 0, 0));
  }
  selectDataSaida(value: NgbDate) {
    this.dataEntrega = new Date(Date.UTC(value.year, value.month - 1, value.day, 0, 0, 0));
  }

  selectDataEntradaOficina(value: NgbDate) {
    if (value == null) {
      this.pedidoForm.patchValue({ dataEntradaOficina: null});
    } else {
      this.pedidoForm.patchValue({ dataEntradaOficina: new Date(Date.UTC(value.year, value.month - 1, value.day, 0, 0, 0)) });
    }
  }

}
